import { Box, Button, CircularProgress, Paper } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import PasswordInput from "../components/PasswordInput";
import { resetPassword } from "../services/auth";
import { useNavigate, useParams } from "react-router-dom";

const ResetPassword = () => {

  const [password, set_password] = useState('');
  const [confirm_password, set_confirm_password] = useState('');
  const [is_saving, set_is_saving] = useState(false);

  const params = useParams();
  const navigate = useNavigate();

  const token = params.token;

  const handleSendMail = async (e) => {
    e.preventDefault();

    if(password === confirm_password){
      set_is_saving(true);
  
      const {data, error} = await resetPassword({ password : password, token : token })
      set_is_saving(false);
      if(data){
        if(data.success){
          enqueueSnackbar('Password updated successfully !', {
            variant : 'success'
          })

          navigate('/sign-in')
        }else{
          showResetError();
        }
      }
      if(error){
        if(error.status === 401){
          enqueueSnackbar('Password reset link expired !', {
            variant : 'error'
          })
        }else{
          showResetError()
        }
      }
    }else{
      enqueueSnackbar('New password and confirm password did not match', {
        variant : 'warning'
      })
    }
  }
  
  const showResetError = () => {
    enqueueSnackbar('Error while resetting password !', {
      variant : 'error'
    })
  }

  return(
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      minHeight='100vh'
    >
      <form
        onSubmit={handleSendMail}
      >
        <Paper
          elevation={3}
          sx={{
            width : '550px',
            padding : '20px'
          }}
        >

          <PasswordInput
            fullWidth
            variant="outlined"
            label = 'New Password'
            size="medium"
            sx={{
              marginBottom : '20px'
            }}
            value={password}
            onChange={(e) => set_password(e.target.value)}
          />
          <PasswordInput
            fullWidth
            variant="outlined"
            label = 'Confirm New Password'
            size="medium"
            sx={{
              marginBottom : '20px'
            }}
            value={confirm_password}
            onChange={(e) => set_confirm_password(e.target.value)}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled = {
              is_saving ||
              !Boolean(password) ||
              !Boolean(confirm_password)
            }
          >
            {is_saving ? <CircularProgress /> : 'Save'}
          </Button>
        </Paper>
      </form>
    </Box>
  )
}

export default ResetPassword;